const BlogData = [
  "We invite you to check out our blog section, where we provide some information on web development",
  "Here, you'll find a variety of in-depth guides and resources to help you learn new skills and technologies.",
];

export default BlogData;
